module.exports = __webpack_public_path__ + "img/tunelera3d.0f2ac3db.jpg";